import React from 'react';

const SimmerItem = () => {
  return (
    <div className='w-[100%] flex justify-center items-center'>

    <div className='w-full lg:w-[80%] h-80 bg-white rounded-2xl'>
    </div>
    </div>
  );
}

export default SimmerItem;
